import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import { MatDialogRef, MatDialog, MatSnackBar } from 'app/main/content/global-component/control-template';
import { DatatableService } from 'app/main/content/global-component/datatable/datatable.service';
import { HelpersService } from 'app/main/content/services/helpers/helpers.service';
import { WorkspaceQuery } from 'app/main/content/state/workspaceState/workspace.query';
import * as moment from 'moment';
import { NgxTuiCalendarComponent } from 'ngx-tui-calendar';
import { Subject } from 'rxjs';
import { AgentProposalSelectionService } from './agent-proposal-selection-popup.service';
var AgentProposalSelectionPopupComponent = /** @class */ (function () {
    function AgentProposalSelectionPopupComponent(dialog, calendarService, dataTableService, snackBar, translationLoader, translate, helperService, workspaceQuery, route, router, dialogRef, data) {
        this.dialog = dialog;
        this.calendarService = calendarService;
        this.dataTableService = dataTableService;
        this.snackBar = snackBar;
        this.translationLoader = translationLoader;
        this.translate = translate;
        this.helperService = helperService;
        this.workspaceQuery = workspaceQuery;
        this.route = route;
        this.router = router;
        this.dialogRef = dialogRef;
        this.data = data;
        this.timeRange = [
            "00:00",
            "01:00",
            "02:00",
            "03:00",
            "04:00",
            "05:00",
            "06:00",
            "07:00",
            "08:00",
            "09:00",
            "10:00",
            "11:00",
            "12:00",
            "13:00",
            "14:00",
            "15:00",
            "16:00",
            "17:00",
            "18:00",
            "19:00",
            "20:00",
            "21:00",
            "22:00",
            "23:00"
        ];
        this.startDay = "07:00";
        this.endDay = "21:00";
        this.slotDuration = "00:30:00";
        this.timeGap = [
            {
                title: '15 mins',
                value: "00:15:00"
            },
            {
                title: '30 mins',
                value: "00:30:00"
            },
            {
                title: '1 hr',
                value: "01:00:00"
            },
            {
                title: '2 hr',
                value: "02:00:00"
            }
        ];
        this.unsubscribe = new Subject();
        this.defView = '';
        this.events = [];
        this.loading = true;
        this.mqFilter = '';
        this.options = {};
        this.showUserFilter = false;
        this.dtOptions = {};
        this.filters = {};
        this.dataTablesParameters = {};
        this.manageGlobalFilter = false;
        this.managePrivateFilter = false;
        this.showGlobalFilter = true;
        this.showPrivateFilter = true;
        this.taskView = ['task', 'milestone'];
    }
    AgentProposalSelectionPopupComponent.prototype.openEvent = function (eventId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var eventDoc;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.calendarService.getEvent(eventId)];
                    case 1:
                        eventDoc = _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AgentProposalSelectionPopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.data && this.data.eventId) {
            this.calendarService.currentEventId = this.data.eventId;
        }
        else {
            this.calendarService.currentEventId = null;
        }
        console.log("this.data ", this.data);
        if (this.data && this.data.eventDoc && this.data.eventDoc.startDateTime) {
            this.selectedEventData = this.data.eventDoc || this.selectedEventData;
        }
        this.route.queryParams.subscribe(function (data) {
            if (data.eventId && _this.eventId !== data.eventId) {
                _this.openEvent(data.eventId);
            }
            _this.changeCalendarView("agendaThreeDay");
        });
        this.translate.onLangChange.subscribe(function (lang) {
            if (lang && lang.lang) {
                _this.setCalendarLanguage(lang.lang);
            }
        });
        this.calendarService.calendarId = '';
        this.calendarService.calendarId = this.regId;
        // means control type
        if (this.parentId) {
            this.calendarService.filtertype = 'allCalendar';
        }
        else {
            this.calendarService.filtertype = 'myCalendar';
        }
        this.mqFilter = this.hardFilter;
        this.calendarService.resolveAll()
            .then(function (data) {
            console.log("events == ", _this.calendarService.calendarViewSettings.events);
            _this.view = 'calendar';
            // this.translationLoader.loadTranslations(english, polish);
            _this.helperService.getTrans('calendar-template')
                .then(function (data2) {
                _this.translationLoader.loadTranslationsV2(data2);
            }).catch(function (err) {
                console.info(err);
            });
            _this.calendarService.calendarViewSettings.locale = _this.translate.getDefaultLang();
            _this.translate.onLangChange.subscribe(function (lang) {
                _this.calendarService.calendarViewSettings.locale = (lang && lang.lang) || 'en';
                _this.containerEl.fullCalendar('destroy');
                _this.containerEl = $('#calendar');
                _this.containerEl.fullCalendar(_this.calendarService.calendarViewSettings);
                console.log("events == ", _this.calendarService.calendarViewSettings.events);
                _this.containerEl.fullCalendar('addEventSource', _this.calendarService.calendarViewSettings.events);
            }, function (err) {
                console.info(err);
            });
            _this.events = _this.calendarService.events || [];
            _this.calendarService.calendarViewSettings.eventMouseout = function (calEvent, jsEvent) {
                $(this).css('z-index', 8);
                $('.tooltipevent').remove();
            };
            _this.calendarService.calendarViewSettings.eventMouseover = function (calEvent, jsEvent) {
                var tooltip = "\n      <div class=\"tui-full-calendar-floating-layer tui-view-17 tooltipevent\" style=\"position:absolute;z-index:10001;\" ><div class=\"tui-full-calendar-popup tui-full-calendar-popup-detail\">\n  <div class=\"tui-full-calendar-popup-container\">\n    <div class=\"tui-full-calendar-popup-section tui-full-calendar-section-header\">\n      <div>\n        <span class=\"tui-full-calendar-schedule-private tui-full-calendar-icon tui-full-calendar-ic-private\"></span>\n        <span class=\"tui-full-calendar-schedule-title\" style=\"color: darkblue;\">" + (calEvent.title || '&nbsp') + "</span>\n      </div>\n      <div class=\"tui-full-calendar-popup-detail-date tui-full-calendar-content\">" + moment(calEvent.start).format('YYYY-MM-DD HH:mm') + " - " + moment(calEvent.end).format('YYYY-MM-DD HH:mm') + "</div>\n    </div>\n    <div class=\"tui-full-calendar-section-detail\">\n        <div class=\"tui-full-calendar-popup-detail-item\"><span class=\"tui-full-calendar-icon tui-full-calendar-ic-location-b\"></span><span class=\"tui-full-calendar-content\">" + (calEvent.info_responsible || '') + "</span></div>\n        \n        <div class=\"tui-full-calendar-popup-detail-item tui-full-calendar-popup-detail-item-indent\"><span class=\"tui-full-calendar-icon tui-full-calendar-ic-user-b\"></span><span class=\"tui-full-calendar-content\">anyone</span></div>\n        \n        <div class=\"tui-full-calendar-popup-detail-item\"><span class=\"tui-full-calendar-icon tui-full-calendar-calendar-dot\" style=\"background-color: #00a9ff\"></span><span class=\"tui-full-calendar-content\">" + (calEvent.info_type || '') + "</span></div>\n        \n    </div>\n  </div>\n  <div class=\"tui-full-calendar-popup-top-line\" style=\"background-color: #00a9ff\"></div>\n  <div id=\"tui-full-calendar-popup-arrow\" class=\"tui-full-calendar-popup-arrow tui-full-calendar-arrow-left\">\n    <div class=\"tui-full-calendar-popup-arrow-border\">\n        <div class=\"tui-full-calendar-popup-arrow-fill\"></div>\n    </div>\n  </div>\n</div>\n</div>";
                $('body').append(tooltip);
                $(this).mouseover(function (e) {
                    $(this).css('z-index', 10000);
                    $('.tooltipevent').fadeIn('500');
                    $('.tooltipevent').fadeTo(10, 1.9);
                }).mousemove(function (e) {
                    $('.tooltipevent').css('top', e.pageY + 10);
                    $('.tooltipevent').css('left', e.pageX + 20);
                });
            };
            _this.calendarService.calendarViewSettings.eventRender = function (eventObj, $el) {
            };
            _this.calendarService.calendarViewSettings.events = function (start, end, timezone, cb) {
                console.log("/*/*/*/ ", start, end);
                _this.calendarService.filterDateRange.start = start.format() || new Date((new Date().getTime() - (60000 * 60 * 24)));
                _this.calendarService.filterDateRange.end = end.format() || new Date();
                _this.calendarService.getEvents(_this.mqFilter)
                    .then(function (events) {
                    console.log("events == 33", _this.calendarService.calendarViewSettings.events);
                    cb(events || []);
                }).catch(function (err) {
                    console.info(err);
                });
            };
            _this.calendarService.calendarViewSettings.eventClick = function (element, event) {
                // this.editEvent('edit', element);
                console.log("event", event);
                console.log("element", element);
                // this.selectedStartDateTime = element.start
            };
            _this.calendarService.calendarViewSettings.viewRender = function (view, element) {
                _this.calendarService.filterDateRange.start = view.start.format() || new Date((new Date().getTime() - (60000 * 60 * 24)));
                _this.calendarService.filterDateRange.end = view.end.format() || new Date();
                if (_this.calendarService.calenderFilter) {
                    _this.calendarService.calenderFilter['registredDataTime'] = {
                        $gte: _this.calendarService.filterDateRange.start,
                        $lte: _this.calendarService.filterDateRange.end
                    };
                }
            };
            _this.calendarService.calendarViewSettings.select = function (start, end, jsEvent, view, resource) {
                var defaultValue = {
                    start: start.format(),
                    end: end.format()
                };
                console.log("defaultValue - ", defaultValue);
                _this.selectedStart = defaultValue.start;
                if (view && view.type === "month") {
                    defaultValue = {
                        start: start.format("YYYY-MM-DD ") + moment().format("HH:mm"),
                        end: start.format("YYYY-MM-DD ") + moment().add(30, 'minute').format("HH:mm")
                    };
                }
                _this.selectedEventData = {
                    start: defaultValue.start,
                    end: moment(defaultValue.start).add(_this.data.duration, "hour"),
                    expireDateTime: moment().add(_this.data.expiryTime, "hour"),
                    subject: _this.data.subject,
                    caseSignature: _this.data.caseSignature
                };
                if (_this.calendarService.currentEventId) {
                    _this.calendarService.events = _this.calendarService.events.map(function (ele) {
                        if (ele && ele._id === _this.calendarService.currentEventId) {
                            ele.start = moment(_this.selectedEventData.start).format();
                            ele.end = moment(_this.selectedEventData.end).format();
                        }
                        return ele;
                    });
                }
                else {
                    var temp = _this.calendarService.events.findIndex(function (ele) { return (ele && ele._id === "add"); });
                    if (temp === -1) {
                        _this.calendarService.events.push(tslib_1.__assign({}, _this.selectedEventData, { textColor: "white", backgroundColor: "red", _id: "add" }));
                    }
                    else {
                        _this.calendarService.events = _this.calendarService.events.map(function (ele) {
                            if (ele && ele._id === "add") {
                                ele.start = _this.selectedEventData.start;
                                ele.end = _this.selectedEventData.end;
                            }
                            return ele;
                        });
                    }
                }
                // this.containerEl.fullCalendar('rerenderEvents');
                // this.containerEl.fullCalendar('render');
                console.log("---------", _this.calendarService.events);
                if (_this.parentId) {
                    defaultValue['parentId'] = _this.parentId;
                }
                if (_this.parentCaseId) {
                    defaultValue['parentCaseId'] = _this.parentCaseId;
                }
            };
            _this.calendarService.calendarViewSettings.eventDrop = function (event, delta, revertFunc) {
                if (event && event['originalRec']) {
                    event['originalRec'] = event['originalRec'] || {};
                    event['originalRec']['start'] = moment(event.start).format();
                    event['originalRec']['end'] = moment(event.end).format();
                    _this.updateEvent(event);
                }
            };
            _this.calendarService.calendarViewSettings.eventResize = function (event, delta, revertFunc, jsEvent, ui, view) {
                if (event && event['originalRec']) {
                    event['originalRec'] = event['originalRec'] || {};
                    event['originalRec']['start'] = moment(event.start).format();
                    event['originalRec']['end'] = moment(event.end).format();
                    _this.updateEvent(event);
                }
            };
            _this.loading = false;
            _this.calendarService.calendarViewSettings.locale = 'pl';
            setTimeout(function () {
                _this.containerEl = $('#calendar');
                _this.containerEl.fullCalendar(_this.calendarService.calendarViewSettings);
                _this.setCalendarLanguage(_this.translate.currentLang);
            }, 400);
        }).catch(function (err) {
            console.info(err);
            _this.snackBar.open(err || 'Error occured while getting data', 'Okay', {
                duration: 2000,
            });
        });
    };
    AgentProposalSelectionPopupComponent.prototype.setCalendarLanguage = function (lang) {
        if (this.containerEl && this.containerEl.fullCalendar) {
            this.containerEl.fullCalendar('option', 'locale', lang);
        }
    };
    AgentProposalSelectionPopupComponent.prototype.ngAfterViewInit = function () {
    };
    AgentProposalSelectionPopupComponent.prototype.addEventButton = function () {
        // tslint:disable-next-line:radix
        var diff = (this.calendarService.slotDuration && parseInt(this.calendarService.slotDuration)) || 30;
        var defaultData = {
            start: moment().format('YYYY-MM-DD HH:mm'),
            end: moment((new Date().getTime()) + (60000 * diff)).format('YYYY-MM-DD HH:mm')
        };
        if (this.parentId) {
            defaultData['parentId'] = this.parentId;
        }
        if (this.parentCaseId) {
            defaultData['parentCaseId'] = this.parentCaseId;
        }
    };
    AgentProposalSelectionPopupComponent.prototype.updateEvent = function (event) {
        var _this = this;
        this.calendarService.updateEvent(event['originalRec'])
            .then(function (data) {
            return _this.calendarService.getEvents(_this.mqFilter);
        })
            .then(function (eventList) {
            _this.calendarService.calendarViewSettings.events = eventList || [];
            _this.snackBar.open('Event Updated', 'Okay', {
                duration: 2000,
            });
        }).catch(function (err) {
            _this.snackBar.open(err || 'Error occured while getting data', 'Okay', {
                duration: 2000,
            });
        });
    };
    AgentProposalSelectionPopupComponent.prototype.filterEvents = function (filterType, filterValue) {
        if (filterType === 'info_status') {
            if (filterValue) {
                this.calendarService.statusFilter = filterValue;
                this.calendarService.customFilter['info_status'] = filterValue;
            }
            else {
                delete this.calendarService.customFilter['info_status'];
            }
        }
        else if (filterType === 'info_type') {
            if (filterValue) {
                this.calendarService.customFilter['info_type'] = filterValue;
            }
            else {
                delete this.calendarService.customFilter['info_type'];
            }
        }
        else if (filterType === 'info_responsible') {
            delete this.calendarService.customFilter['info_responsible'];
        }
        // if (this.view === 'dataTable') {
        //   this.dataTableService.onFilterChanged.next(this.calendarService.customFilter);
        // } else {
        this.reRenderCalendarData(this.mqFilter);
        // }
    };
    AgentProposalSelectionPopupComponent.prototype.changeCalendarView = function (type) {
        this.calendarService.calendarViewSettings.defaultView = type;
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: { view: type },
            queryParamsHandling: 'merge'
        });
        // if (type === 'list') {
        //   // datatable view..
        //   this.view = 'dataTable';
        //   this.dataTableService.onDataChanged.next({
        //     regId: this.calendarService.regId,
        //   });
        //   this.dataTableService.onFilterChanged.next(this.calendarService.customFilter);
        // } else {
        this.view = 'calendar';
        // this.containerEl = $('#calendar');
        if (this.containerEl) {
            this.containerEl.fullCalendar('changeView', type);
            this.calendarService.calendarViewSettings.defaultView = type;
        }
        // }
    };
    AgentProposalSelectionPopupComponent.prototype.removeSelecteUser = function (i) {
        if (this.calendarService.customFilter['info_responsible'].$in) {
            this.calendarService.customFilter['info_responsible'].$in.splice(i, 1);
            this.reRenderCalendarData(this.mqFilter);
        }
    };
    AgentProposalSelectionPopupComponent.prototype.reRenderCalendarData = function (mqHardFilter) {
        var _this = this;
        this.calendarService.getEvents(mqHardFilter)
            .then(function (eventList) {
            eventList = eventList || [];
            _this.containerEl.fullCalendar('refetchEvents');
            _this.snackBar.open('Updating', 'Okay', {
                duration: 2000,
            });
        }).catch(function (err) {
            _this.snackBar.open(err || 'Error occured while getting data', 'Okay', {
                duration: 2000,
            });
        });
    };
    AgentProposalSelectionPopupComponent.prototype.changeSlotDuration = function (item) {
        this.calendarService.calendarViewSettings.slotDuration = item.value;
        this.slotDuration = item.value;
        // this.containerEl.fullCalendar('refetchEvents');
        this.containerEl.fullCalendar('option', 'slotDuration', item.value);
    };
    AgentProposalSelectionPopupComponent.prototype.onSelectionChange = function (eve, type) {
        console.log(eve);
        this.containerEl.fullCalendar('option', type, eve.value);
    };
    AgentProposalSelectionPopupComponent.prototype.submit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var dataToInsert_1, tempIndex;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                try {
                    dataToInsert_1 = {
                        type: "new",
                        expiryTime: this.data.expiryTime,
                        start: this.selectedStart,
                        end: moment(this.selectedStart).add(this.data.duration, "hour")
                    };
                    this.calendarService.events = this.calendarService.events || [];
                    tempIndex = this.calendarService.events.filter(function (ele) { return (ele && ele.start && ele.end && (moment(ele.start).isBetween(dataToInsert_1.start, dataToInsert_1.end) || moment(ele.end).isBetween(dataToInsert_1.start, dataToInsert_1.end))); });
                    if (tempIndex && tempIndex.length && tempIndex[0] && tempIndex[0]._id !== this.calendarService.currentEventId) {
                        this.helperService.openConfirmPopUp("Time slot is conflicting with one or more task events, are you sure you want to add?")
                            .subscribe(function (data) {
                            if (data) {
                                _this.saveOrUpdate(dataToInsert_1);
                            }
                        });
                    }
                    else {
                        this.saveOrUpdate(dataToInsert_1);
                    }
                }
                catch (error) {
                    console.error("error", error);
                    this.loading = false;
                }
                return [2 /*return*/];
            });
        });
    };
    AgentProposalSelectionPopupComponent.prototype.saveOrUpdate = function (dataToInsert) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.loading = true;
                        if (this.data.eventId) {
                            dataToInsert.type = "update";
                            dataToInsert.eventId = this.data.eventId;
                        }
                        return [4 /*yield*/, this.helperService.postRequest("api/shared-service/cal-event/" + this.data.serviceId, dataToInsert)];
                    case 1:
                        data = _a.sent();
                        this.helperService.showInfo("Slot added");
                        this.dialogRef.close({ startDateTime: this.selectedStart, eventId: data._id, endDateTime: data.end, subject: data.subject, state: data.state, serviceId: data.serviceId, expireDateTime: data.expireDateTime, caseSignature: data.caseSignature });
                        this.loading = false;
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error("error", error_1);
                        this.loading = false;
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return AgentProposalSelectionPopupComponent;
}());
export { AgentProposalSelectionPopupComponent };
